export * from "./atoms";
export * from "./molecules";
export * from "./organisms";
export * from "./messages";

import { CategoryAtoms } from "./atoms";
import { CategoryMessages } from "./messages";
import { CategoryMolecules } from "./molecules";
import { CategoryOrganisms } from "./organisms";

export const CategoryComponents = [...CategoryAtoms, ...CategoryMolecules, ...CategoryOrganisms, ...CategoryMessages];
